'use client'

import { Link } from '@/i18n/routing'
import { useState } from 'react'
import { useTranslations } from 'next-intl'

import Image from 'next/image'

import { getNavLinks } from '@/lib/constants/navigation'
import { MaterialIcon } from '@/components/ui/MaterialIcon'

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const t = useTranslations('Nav')
  const navLinks = getNavLinks((key) => t(key))

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <Link href="/" className="flex items-center gap-2">
          <Image
            src="/logo.svg"
            alt="We Love Convert Logo"
            width={136}
            height={40}
            className="h-10 w-auto"
            priority
            unoptimized
          />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-primary"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            className="inline-flex md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            title="Menu"
            aria-label="Menu"
          >
            <MaterialIcon name={mobileOpen ? 'close' : 'menu'} className="text-2xl" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-slate-100 bg-white px-6 py-4 md:hidden">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-slate-600 transition-colors hover:text-primary"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  )
}
